import {
  faCancel,
  faCheck,
  faEllipsisVertical,
  faPenToSquare,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { formatTime, formatDate } from 'utils/helpers'
import moment from 'moment'
import { useState } from 'react'
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap'
import { unsendMessage } from 'store/Chats/actions'
import { useDispatch } from 'react-redux'
import defaultAvatar from '../../../assets/img/brand/img_avatar.png'

function Message({
  message,
  loggedInUser,
  lastMessage,
  setInputValue,
  editInfo,
  setEditInfo,
  isGroup,
  isFirstInBlock,
  isLastInBlock,
}) {
  const [isHovered, setIsHovered] = useState(false)
  const dispatch = useDispatch()

  const isEditing = editInfo?.messageId === message.id
  const myMessage = loggedInUser?.id === message?.sender_id

  return (
    <div
      className='w-100 d-flex'
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        marginTop:
          isGroup && isFirstInBlock && message.index !== 0 ? '20px' : '0px',
      }}
    >
      {isGroup &&
        (() => {
          let avatarUrl = defaultAvatar
          try {
            if (message?.sender_avatar) {
              const parsedAvatar = JSON.parse(message.sender_avatar)
              if (parsedAvatar?.url) {
                avatarUrl = parsedAvatar.url
              }
            }
          } catch (e) {
            console.warn(
              'Invalid JSON in sender_avatar:',
              message.sender_avatar
            )
          }

          return (
            <img
              src={avatarUrl}
              alt='Sender Avatar'
              style={{
                width: '30px',
                height: '30px',
                borderRadius: '50%',
                marginTop: 'auto',
                marginRight: '5px',
                visibility:
                  isGroup && isLastInBlock && !myMessage ? '' : 'hidden',
              }}
            />
          )
        })()}

      <div
        style={{ position: 'relative' }}
        title={formatDate(message?.created_at)}
        key={message.id}
        className={`message shadow-lg mb-2 ${
          myMessage ? 'my-message' : 'bg-white text-black'
        } ${editInfo.editMode && !isEditing ? 'onEdit' : ''}`}
      >
        {message?.message ? (
          <>
            {isGroup && isFirstInBlock && !myMessage && (
              <p className='text-info font-weight-bold'>
                {message?.sender_first_name} {message?.sender_last_name}
              </p>
            )}
            <p className='message-text boxShadow'>{message?.message}</p>
          </>
        ) : (
          <i className='message-text boxShadow'>
            <FontAwesomeIcon icon={faCancel} /> Message deleted.
          </i>
        )}

        {/* Dropdown (edit/delete) */}
        <UncontrolledDropdown
          style={{
            position: 'absolute',
            top: '15%',
            left: '-35px',
          }}
        >
          {isHovered && myMessage && message?.message && (
            <DropdownToggle
              className='actionToggle'
              role='button'
              size='sm'
              onClick={(e) => e.preventDefault()}
            >
              <FontAwesomeIcon icon={faEllipsisVertical} size={'lg'} />
            </DropdownToggle>
          )}

          <DropdownMenu className='dropdown-menu-arrow course-dropdown'>
            <DropdownItem
              className='actionIcon actionIconEdit'
              onClick={() => {
                setEditInfo({ messageId: message.id, editMode: true })
                setInputValue(message.message)
              }}
            >
              <FontAwesomeIcon
                icon={faPenToSquare}
                className='dropdown-item-icon'
              />
              {' Edit'}
            </DropdownItem>
            <DropdownItem
              onClick={() => dispatch(unsendMessage(message.id))}
              className='actionIcon actionIconDelete'
            >
              <FontAwesomeIcon
                icon={faTrashAlt}
                className='dropdown-item-icon'
              />
              {' Unsend'}
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>

        {/* Message meta (read receipts, timestamps) */}
        <div className='text-right ml-2 d-flex align-items-center justify-content-end mt-1'>
          {myMessage && message?.message && (
            <>
              {!lastMessage?.last_message_read &&
              moment(message?.created_at).isAfter(
                moment(lastMessage?.updated_at)
              ) ? (
                <>
                  <FontAwesomeIcon icon={faCheck} />
                  <FontAwesomeIcon icon={faCheck} />
                </>
              ) : (
                <div>
                  <FontAwesomeIcon icon={faCheck} className='text-primary' />
                  <FontAwesomeIcon icon={faCheck} className='text-primary' />
                </div>
              )}
            </>
          )}
          {message?.created_at && !isNaN(new Date(message.created_at)) && (
            <span className='ml-1'>
              {message?.created_at !== message?.updated_at &&
                message?.message &&
                'Edited'}{' '}
              {formatTime(message.created_at)}
            </span>
          )}
        </div>
      </div>
    </div>
  )
}

export default Message
